module.exports = __webpack_public_path__ + "media/images/icons/icons_large/46_church-fa6735f5e66f1c7a7a80dda2118c55b7.png";